const deployment = process.env.REACT_APP_DEPLOYMENT as string;
export const deploymentConfig = {
  deployment,
};
